import type { ApiClient } from '../client'
import type {
  CreateCustomerRequest,
  Customer,
  CustomerPreferences,
  ListCustomersQuery,
  PutPreferencesRequest,
  UpdateCustomerRequest,
} from '../types'

/** src/modules/customers/controllers/customers.controller.ts */
export function customersEndpoints(api: ApiClient) {
  return {
    /** Plain array, prefix search, ≤ 100 rows — the backend has no cursor here. */
    list: (query: ListCustomersQuery = {}) =>
      api.get<readonly Customer[]>('customers', {
        query: {
          q: query.q,
          do_not_contact:
            query.do_not_contact === undefined ? undefined : String(query.do_not_contact),
          limit: query.limit,
        },
      }),
    get: (id: string) => api.get<Customer>(`customers/${id}`),
    create: (body: CreateCustomerRequest) => api.post<Customer>('customers', body),
    update: (id: string, body: UpdateCustomerRequest) =>
      api.patch<Customer>(`customers/${id}`, body),
    preferences: (id: string) => api.get<CustomerPreferences>(`customers/${id}/preferences`),
    putPreferences: (id: string, body: PutPreferencesRequest) =>
      api.put<CustomerPreferences>(`customers/${id}/preferences`, body),
    /** Erasure: the row survives, anonymised (`customers:anonymise`). */
    anonymise: (id: string) => api.delete<Customer>(`customers/${id}`),
  }
}
